export default {
    payment_failed_please_contact_admin: 'Uw betaling kon niet worden verwerkt. Neem contact op met de ondersteuning.',
    login: 'Inloggen',
    forgot_password: "Wachtwoord vergeten?",
    english: "English",
    german: "Deutsch",
    french: "Français",
    italian: "Italiano",
    dutch: "Nederlands",
    spanish: "Español",
    portuguese: "Português",
    english_short: "EN",
    german_short: "DE",
    french_short: "FR",
    italian_short: "IT",
    dutch_short: "NL",
    spanish_short: "ES",
    portuguese_short: "PT",
    no_more_photos_for_moderation: "Er zijn geen foto's meer om te modereren. Kom later nog eens terug. Bedankt voor je hulp 😘",
    timezone: 'Tijdzone',
    timezone_type_automatic: 'Uw tijdzone wordt automatisch gedetecteerd',
    timezone_type_manually: 'Uw gekozen tijdzone wordt vergrendeld',
    invalid_token_message: 'Om veiligheidsredenen is uw toegangstoken verlopen.\n' +
        'Vraag een nieuw token aan om verder te gaan.',
    try_again:'Opnieuw proberen',
    add_links_to_profiles_events_clubs:'Voeg links toe naar profielen, evenementen en clubs',
    you_can_add_only_twenty_links: 'Je kunt maar 20 links toevoegen',
    enter_your_social_network_handle: 'Voer je {social_network}-gebruikersnaam in',
    follow: 'Volgen',
    message: 'Message',
    message_copied: 'Succesvol gekopieerd',
    copied_from_clipboard: 'Copied from clipboard',
    reply: "antwoorden",
    copy: "kopiëren",
    delete_for_all: "voor iedereen verwijderen",
    now: "NU!",
    meet_now:"Ontmoet NU!",
    activate_meet_now:"Activeer \"NU!\" en laat zien dat je klaar bent om af te spreken.",
    activate_now:"Activeer NU!",
    deactivate_now:"Deactiveer NU!",
    meet_now_mini_text:"\"NU!\" blijft 30 minuten actief.",
    finished:"Klaar?",
    over_now:"...NU! voorbij",
    headline_or_nickname:"Kop of Bijnaam",
    meet_now_upgrade_to_pro:"\"NU!\" is vandaag al {0} keer geactiveerd. Upgrade naar PRO om \"NU!\" onbeperkt opnieuw te activeren.",
    activate_meet_now_n_times:"Activeer \"NU!\" tot {0} keer per dag. PRO-leden kunnen onbeperkt activeren.",

    email: "E-mail",
    email_or_username: "E-mail of bijnaam",
    photo: "Foto",
    password: "jouw wachtwoord",
    verify_age: 'Leeftijd verifiëren',
    verifying_age: 'Leeftijd verifiëren',
    verification_success_title: 'Verificatie voltooid',
    verification_success_desc: 'Je leeftijd is succesvol geverifieerd.',
    verification_failed_title: 'Verificatie mislukt',
    verification_failed_desc: 'De verificatie is niet geslaagd. Je kunt het opnieuw proberen door een andere foto te selecteren of te uploaden.',
    verification_limit_title: 'Limiet Bereikt',
    verification_limit_desc: 'Je hebt het maximumaantal leeftijdsverificatie pogingen overschreden. Probeer het later opnieuw.',
    try_again_in: 'Probeer het opnieuw over',
    close: 'Sluiten',
    okay: 'Oké',
    start_verification: 'start verificatie',
    choose_photo: 'Kies foto',
    age_verification_photo_instruction: 'Zorg voor een foto waarop je gezicht duidelijk zichtbaar is. Er mag maar één persoon op de foto staan.',
    age_verification_description: 'Volg de instructies om je leeftijd te verifiëren.',
    verify_now: 'Nu verifiëren',
    stay_logged_in: "Ingelogd blijven?",
    new_to_barebuddy: "Nieuw bij Buddy?",
    join_now: "Nu aanmelden!",
    // what_is_barebuddy: "What is BareBuddy? Find out more",
    recover_password: "Wachtwoord herstellen",
    reset_password: "Wachtwoord opnieuw instellen",
    confirm_password: "Wachtwoord bevestigen",
    recover_now: "Nu herstellen",
    create: "Creëren",
    start: "Begin",
    age_modal:{
        'age_check' : 'Leeftijdscontrole',
        'contain_sensitive_material':'Deze pagina kan gevoelige inhoud bevatten.',
        'you_need_eighteen':'Je moet ouder dan 18 zijn om door te gaan.',
    },
    join_modal:{
        become_a_member: "Word nu lid en geniet van alle functies.",
        its_quick_and_free: "Het is snel en gratis!",
        already_a_member:"Al lid?",
    },
    passwords: {
        password: "Wachtwoorden moeten ten minste zes tekens bevatten en overeenkomen met de bevestiging",
        reset: "Je wachtwoord is opnieuw ingesteld!",
        sent: "Als deze e-mail geregistreerd is, ontvangt je een herstellink.",
        token: "Deze link voor het opnieuw instellen van het wachtwoord is ongeldig.",
        user: "Als deze e-mail geregistreerd is, ontvangt je een herstellink.",
    },
    welcome: {
        what_next: "Wat wil je nu doen?",
        nickname: "Bijnaam",
        nickname_description: "Voltooi nu je profiel.",
        discover: "Ontdek BUDDY",
        discover_description: "Chat, date, chill, gids en nog veel meer om te ontdekken.",
        pro: "Upgraden naar Pro",
        pro_description: "Oneindig veel plezier met de Pro-versie."
    },
    invalid_credentials: "De inloggegevens waren niet juist",
    reg: {
        // step1: "Step 1",
        // step2: "Step 2",
        // step3: "Step 3",
        ready: " 'Klaar',",
        automatic_location: "Automatische locatie",
        manual_location: "Handmatige locatie",
        location_defining: "Locatie definiëren...",
        choose_password: 'Kies een wachtwoord',
        password_looks_good: "Je wachtwoord ziet er goed uit.",
        pick_nickname: "Schrijf een bijnaam voor je Buddy-profiel.",
        nickname: "Bijnaam",
        pick_handle: "Dit is je Buddy-link:",
        suggestions: 'Suggesties',
        handle_available: "De Buddy-link is beschikbaar.",
        upload_photo: "Foto uploaden",
        handle_already_taken : "Deze Buddy-link is al in gebruik.",
        password_description: "uw wachtwoord moet min. 6 tekens lang",
        handle_description : "Je Buddy-link helpt anderen om je profiel te vinden. Je kunt het nu of later in de instellingen wijzigen.",
        birthdate: "Geboortedatum",
        next: "Doorgaan",
        enter_email_address: "Jouw e-mail",
        almost_finished: "Bijna klaar...",
        add_photo_text: "Voeg een foto toe zodat de buddies je kunnen zien.",
        i_am_ready: "Ik ben klaar",
        skip: "Overslaan",
        back: "TERUG",
        add_photo: "Foto toevoegen",
        you_made_it: "Je bent klaar!",
        accept_terms_privacy_text: "Door op \"Doorgaan\" te drukken bevestig ik dat ik 18 jaar of ouder ben en dat ik het {0} heb gelezen en de {1} heb geaccepteerd.",
        accept_terms_privacy_text_barebuddy: "By entering, you agree to our {0} and {1}.",
        terms_of_service: "Terms of Service",
        you_must_be_eighteen: "You must be over 18 years old to enter",
        terms_of_use: "Gebruiksvoorwaarden",
        privacy_policy: "Privacybeleid",
        finish: "Afsluiten",
        cancel: "Annuleren",
        upload: "Uploaden",
        welcome_to_bb: "Welkom bij BUDDY",
        where_are_you_located: "Waar bevind je je?",
        use_current_location: "Gebruik mijn huidige locatie",
        choose_location_manually: "Handmatig locatie kiezen",
        lets_go: "Klaar",
        human_verification_required: "Vul de Captcha-box in om verder te gaan",
        try_another_photo: "probeer een andere foto",
        map: "Kaart",
        use_gps: "GPS gebruiken",
        gps: "GPS",
        type_address: "Voer je adres in",
    },
    links: {
        about_us: "Over ons",
        imprint: "Impressum",
        support: "Ondersteuning",
        terms: "Gebruiksvoorwaarden",
        community_guidelines: "Communityrichtlijnen",
        privacy: "Privacyverklaring",
        billing_support: "Ondersteuning bij facturatie",
    },
    profile_preview: 'Profielvoorbeeld',
    public_gallery: 'Openbare galerij',
    nearby: "Dichtbij",
    recent: "Recent",
    shuffle: "Shuffle",
    favorites: "Favorieten",
    favorites_online: "Favorieten online",
    online: "Online",
    send_photo: "Foto versturen",
    send_location: "Locatie versturen",
    set_location: "Locatie instellen",
    type_something: "Schrijf iets...",
    all: "Allel",
    unread: "Ongelezen",
    pos_of_total: "{position} van {total}",
    block_user: "Gebruiker blokkeren",
    report_user: "Gebruiker rapporteren",
    user_not_found: 'Gebruiker niet gevonden',
    cancel: "Annuleren",
    online_now: "Nu online",
    away: "Onlangs online",
    offline: "Afwezig",
    about: "Over",
    height: "Grootte",
    weight: "Gewicht",
    body: "Lichaam",
    position: "Positie",
    penis: "Penis",
    hiv: "Status",
    drugs: "Candy",
    info: "Info",
    stats: "Profiel",
    photos: "Foto's",
    settings: "Instellingen",
    share: "Delen",

    open_mailbox: 'Open de mailbox',

    about_me: "Over mij",
    tags: "Tags",
    access: "Toegang",
    profile_account: "Account",
    account: "Account",
    logout: "Uitloggen",
    preferences: "Voorkeuren",
    show_age: "Leeftijd laten zien",
    yes: "Ja",
    no: "Nee",
    join: "Aansluiten",
    host: "Hosten",
    member: "Lid",
    language: "Taal",
    unit_system: "Eenhedenstelsel",
    metric: "Metrisch",
    imperial: "Imperial",
    website_design: "Website-ontwerp",
    old: "Oud",
    reset: "Resetten",
    unblock_users: "Gebruikers deblokkeren",
    delete_my_profile: "Mijn profiel verwijderen",
    your_profile_picture: "Profielfoto",
    public_pictures: "Openbare foto's",
    can_select_count: "{count} van {total}",
    make_photo_private: "Foto privé maken",
    make_photo_public: "Foto openbaar maken",
    set_profile_picture: "Instellen als profielfoto",
    delete_photo: "Foto verwijderen",
    display_name: "Bijnaam",
    display_link : 'Buddy link',
    display_club_link_or_title: 'clublink or title',
    location: "Locatie",
    support: "Ondersteuning",
    photo_message: "Fotobericht",
    distance_away: "{distance} afstand",
    set_current_location: "Huidige locatie instellen",
    location_message: "Locatiebericht",
    no_users_around: "Er zijn geen Buddies in jouw buurt",
    no_more_users_around: "Er zijn geen Buddies meer in jouw buurt",
    to_see_members_become_a_member: 'Om meer gebruikers te zien, word even lid.',
    no_chat_messages: "De chatgeschiedenis is leeg",
    no_more_chat_messages: "Er zijn geen berichten meer in de chatgeschiedenis",
    message_not_delivered: "niet afgeleverd - tik om opnieuw te verzenden",
    old_password: "Oud wachtwoord",
    new_password: "Nieuw wachtwoord",
    new_password_confirmation: "Herhaal wachtwoord",
    password_modified: "Je wachtwoord werd met succes aangepast",
    wrong_old_password: "Het oude wachtwoord is onjuistt",
    save: "Opslaan",
    are_you_sure_delete_profile: "Ben je zeker dat je je profiel wilt verwijderen?",
    all_users_unblocked: "Alle gebruikers werden met succes gedeblokkeerd",
    no_tags: "voeg hier je tags toe",
    add_tag: "Typ een tag en druk op Enter",
    link_copied: "Link gekopieerd",

    write_us_help: "Stuur ons een bericht voor hulp, suggesties &amp; meer",
    automatic_location: "Automatische detectie",
    manual_location: "Handmatig locatie instellenn",
    address: "Adres",
    fail_load_location: "Kon geen toegang krijgen tot je locatie. Wil je je locatie handmatig aangeven?",
    fail_auto_choose_manual_location: "Kon geen toegang krijgen tot je locatie. Gelieve je locatie handmatig aan te geven.",
    this_is_profile_picture: "Dit is je profielfoto",
    sure_delete_conversation: "Gespreksgeschiedenis verwijderen?",
    failed_load_user: "Kon het gebruikersprofiel niet laden",
    please_register: "Gelieve aan te melden",
    recover_it: "Wachtwoord herstellen", //we talk here about forgotten 'password' on login form
    not_a_member: "Nog geen lid?",
    fail_block_user: "Kan de gebruiker niet blokkeren",
    user_reported_confirmation: "Bedankt om de gebruiker te rapporteren. We zullen het zo snel mogelijk nakijken",
    register_here: "Hier Aanmelden",
    options: {
        body: {
            slim: "Slim",
            average: "Gemiddeld",
            athletic: "Atletisch",
            muscular: "Gespierd",
            stocky: "Volslank"
        },
        position: {
            top: "Top",
            more_top: "Meer top",
            bottom: "Bottom",
            more_bottom: "Meer bottom",
            versatile: "Versatile"
        },
        hiv: {
            positive: "Positief",
            negative: "Negatief",
            undetectable: "Ondetecteerbaar",
            prep: "PrEP",
            unknown: "Onbekend"
        },
        drugs: {
            yes: "Ja",
            no: "Nee",
            socially: "Soms",
        }
    },
    Sunday: "zondag",
    Monday: "maandag",
    Tuesday: "dinsdag",
    Wednesday: "woensdag",
    Thursday: "donderdag",
    Friday: "vrijdag",
    Saturday: "zaterdag",
    January: "januari",
    February: "februari",
    March: "maart",
    April: "april",
    May: "mei",
    June: "juni",
    July: "juli",
    August: "augustus",
    September: "september",
    October: "oktober",
    November: "november",
    December: "december",
    back: "Terug",
    report_harassment: "Ongewenst gedrag",
    report_fake: "Nep",
    report_spam: "Spam",
    report_under_age: "Minderjarig",
    report_other: "Anders",
    cookies_message: "Cookies helpen ons bij het aanbieden van onze diensten. Door van onze diensten gebruik te maken, gaat u akkoord met ons gebruik van cookies. ",
    learn_more: "Meer lezen",
    profile_is_deleted: "Dit profiel is verwijderd",
    crop_photo: "Foto bewerken",
    install_pwa_ios_message: "Installeer BUDDY op je smartphone: <img src=\"/assets/img/iphone-share-btn.jpg\" style=\"height: 26px\" /> <strong>Add to Home Screen</strong>: <img style=\"height: 30px\" src=\"/assets/img/add-home-screen-en.png\" />",
    you_are_offline: "Het lijkt erop dat je offline bent",
    show_map: "Kaart",
    subscribe_to_newsletter: "Nieuwsbrief",
    emails_reminders: "E-mailoverzicht",
    daily: "Dagelijks",
    weekly: "Wekelijks",
    monthly: "Maandelijks",
    never: "Nooit",
    "validation.imageable": "Afbeeldingstype wordt niet ondersteund. Graag enkel JPG, PNG of GIF afbeeldingen uploaden. ",
    user_blocked_confirmation: "De gebruiker is geblokkeerd",
    search_users: "Bijnaam",
    sure_delete_event: "Dit evenement verwijderen?",

    home: {
        come_inside: 'Kom binnen',
        content_removal : "Inhoud verwijderen",
        bad_boys_society: "Bad Boys Society",
        create_account: "Account aanmaken",
        tagline: "BUDDY",
        fun: "Een betere gay-app bouwen",
        login: "E-mail or bijnaam",
        password: "Wachtwoord",
        log_in: "Inloggen",
        remember_me: "Ingelogd blijven.",
        forgot_password: "Wachtwoord vergeten?",
        new_here: "Nieuw hier?",
        sign_up: "Aanmelden",

        wants: "Laat je kinky kant zien.",
        wants_desc: "Doorgewinterd of gewoon nieuwsgierig - word lid van de BUDDY gemeenschap en ontdek je kinks. Verstuur een por en begin meteen te chattten. Zoek op hashtags om snel kinksters te vinden die met je matchen.<br><br>Kinky afspraakjes, sneller dan ooit tevoren.",

        videos: "Bekijk & deel video's.",
        videos_desc: "Bekijk massa's hete video\'s van leden. Deel je vooraf opgenomen video's in privé-chats of zet ze op je openbare profiel.<br><br>Zoveel plezier heb je nog nooit beleefd.",

        calendar: "Maak samen plezier.",
        calendar_desc: "Maak privé-advertenties in onze agenda. Laat andere buddies zien wat je wilt en wanneer je het wilt. Wil je meer? Organiseer groepen en vind nieuwe vrienden.<br><br>Ontmoet kinksters zoals jij.",

        everywhere: "Wat is jouw kink?",
        everywhere_desc: "Gebruik onze ongecensureerde website of download de BUDDY app.<br><br>Word lid en neem de proef op de som!",

        generation: "Welkom in de Buddyverse",
        generation_desc: "Volgens ons dienen we onze gemeenschap het best door BUDDY voor iedereen toegankelijk te maken. In tegenstelling tot andere apps zijn de meeste functies helemaal gratis. Geen beperkingen, geen vervelende advertenties. We hopen uit te groeien tot de beste en grootste homo-app voor kinky en fetisj levensstijlen. Word nu lid en vertel het verder.<br><br>Meer buddies - meer plezier!",

        sign_up_now: "Nu aanmelden",

        company: "Bedrijf",
        about_us: "Over ons",
        blog: "Blog",
        help: "Help",
        support: "Ondersteuning bij facturatie",

        legal: "Juridisch",
        privacy: "Privacyverklaring",
        terms: "Terms of UsGebruiksvoorwaarden",
        community_guidelines: "Communityrichtlijnen",
        usc: "18 U.S.C. 2257",
        imprint: "Impressum",

        languages: "Talen",
        follow_us: "Volg ons"
    },

    home_old: {
        tagline: "Buddies<br/>&<br/>Benefits",
        easy_raw_free: "MEET MEN ON PREP",
        // responsible_dating: "Responsible bareback dating",
        home_text: `Come inside and meet gay guys near you.
            BUDDY is the first network
            for men on PrEP or TasP.`,
        join_start: "Join now and start dating immediately.",
        get_started: "Get started",
        screen_title1: "Easy.",
        screen_sub1: "On the hunt!",
        screen_text1: "Browse profiles, chat and send your videos with ease.",
        screen_title2: "FUN.",
        screen_sub2: "Pure and natural!",
        screen_text2: "No discussions, no judgement. Save your time. Just chat and meet.",
        screen_title3: "Free.",
        screen_sub3: "Join for free.",
        screen_text3: "Unlimited profile views, messages and pictures. BUDDY lets you have unlimited fun.",
    },

    company: "Bedrijf",
    legal: "Juridisch",
    community_guidelines: "Communityrichtlijnen",
    social_media: "Sociale Media",
    edit_your_photo: "Je bent prachtig!",
    complete_profile: "Mijn profiel vervolledigen",
    add_more_photos: "Meer foto's toevoegen",
    check_out_guys: "Kijk eens naar de Buddies",
    members_login: "Leden hier inloggen",
    change_password: "wachtwoord wijzigen",
    create_your_event_plus: "Creëer je eigen evenement. Klik op +",
    create_new_event: "Creëer een nieuw evenement",
    create_event: "Evenement maken",
    create_your_club_plus: "Creëer je eigen club. Klik op +",
    create_new_club: "Creëer een nieuw club",
    create_club: "Club maken",
    title: "Titel",
    date: "Datum",
    time: "Tijdstip",
    add_event_details: "Voeg meer informatie toe:",
    event_description: "Beschrijving van het evenement",
    club_description: 'Beschrijving',
    club_description_placeholder: 'Waar draait jouw club om?',
    joined_to_club: "is toegetreden",
    left_to_club: "is vertrokken",
    private: "Private",
    public: "Public",
    non_commercial: "non-commercial",
    commercial: "commercial",
    add_tags_optional: "Voeg tags toe (optioneel)",
    select_address: "Selecteer het adres",
    location_details: "Locatiegegevens (optioneel)",
    location_example: "(eg: my flat, venue name)",
    full_address: "Full address",
    city_only: "Only city",
    event_choose_photos: "Foto's voor je evenement kiezen",
    club_choose_photos: "Foto's voor je club kiezen",
    display: "weergeven",
    alternative: '',
    hot: "hete foto (optioneel)",
    preview: 'veilige afbeelding',
    for_censored_app: "voor gecensureerde app",
    visible_only_uncensored_website: "alleen zichtbaar op ongecensureerde website",
    preview_picture: "Voorbeeld van afbeelding",
    submit_event: "Versturen",
    event_address: "Adres van het evenement",
    club_address: 'Stad',
    please_select_preview_picture: "Selecteer een voorbeeldafbeelding",
    set_preview_picture: "Instellen als voorbeeldafbeelding",
    event_successfully_added: "Je evenement is met succes toegevoegd",
    event_successfully_updated:"Je evenement is succesvol bijgewerkt.",
    no_events_around: "Geen evenementen in de buurt",
    no_more_event_around: "Geen evenementen meer in de buurt",
    club_successfully_added: 'Je club is met succes toegevoegd',
    no_clubs_around: 'Geen clubs in de buurt',
    no_more_club_around: 'Geen clubs meer in de buurt',
    edit: "Bewerken",
    recipient_will_not_see_you: "De ontvanger zal uw echte profiel niet zien.",
    public_videos: "Openbare video's",
    send: "Verzenden",
    event_choose_videos: "Kies video's voor je evenement",
    delete_video: "Video verwijderen",
    add_video: "Video toevoegen",
    videos: "Video's",
    play_video: "Video afspelen",
    video_uploaded_processing: "Je video is met succes geüpload en wordt op dit moment verwerkt. We laten het je weten zodra hij klaar is.",
    video_processed: "Je video is klaar voor gebruik",
    video_message: "Videobericht",
    sure_delete_photo: "Deze foto verwijderen?",
    sure_delete_video: "Deze video verwijderen?",
    too_hot: "Te heet",
    notifications: "Notificaties",
    push_notifications: "Pushmeldinge",
    help: "Help",
    profile: "Profiel",
    user_blocked: "Je hebt deze gebruiker geblokkeerd of hij heeft jou geblokkeerd.",
    open_blocked_users: "Lijst met geblokkeerde gebruikers openen",
    faq: "FAQ",
    support_chat: "Chatondersteuning",
    click_here_tutorials: "Klik hier voor tutorials",
    send_direct_message: "Stuur ons een direct bericht",
    app: "App",
    security: "Beveiliging",
    notification_sound: "Meldingsgeluid",
    deactivate_my_profile: "Mijn profiel deactiveren",
    deactivate_or_delete_my_profile: "Mijn profiel deactiveren of verwijderen",
    customize_sharing_links: "Koppelingen voor delen aanpassen",
    delete_all_sharing_links: "Alle links voor delen verwijderen",
    delete_all: "Verwijder alles",
    deactivate_account: "Account deactiveren",
    taking_break_buddy: "Even weg van BUDDY?",
    deactivate_text_description: "Deactiveer je profiel en verdwijn volledig van de radar en zoekopdrachten.",
    deactivate: "Deactiveren",
    delete_profile_text: "Als je BUDDY voorgoed wilt verlaten, {0} om je profiel te verwijderen. Dit is permanent en kan niet ongedaan gemaakt worden. Je zult een nieuw profiel moeten aanmaken als je terug wilt komen. Vergeet niet, every buddy needs some BUDDY",
    click_here: "klik hiere",
    are_you_sure_deactivate_profile: "Weet je zeker dat je je profiel wil deactiveren?",
    inactive_profile: "Inactief profiel",
    account_is_deactivated: 'Je fraaie BUDDY profiel is momenteel gedeactiveerd. Klik "Activeren" om terug te komen."',
    activate: "Activeren",
    leave: "Verlaten",
    profile_is_deactivated: "Dit profiel is momenteel gedeactiveerd",
    prep_safer_use: "PrEP, TasP, STD, Safer use",
    information_education: "Information & Education",
    prep_chat: "PrEP Chat",
    channel_prep_questions: "Channel for 1:1 PrEP questions",
    censored_event_title: "***Content Warning***",
    censored_event_description: "***This event may contain sensitive material*** <br /><br />Your media settings are configured to warn you about sensitive material. <br />To view it, you need to change your selection in your safety settings",
    censored_content_warning: "Je media instellingen zijn zo geconfigureerd dat je wordt gewaarschuwd voor gevoelig materiaal. Om het te kunnen zien, dien je de selectie in je veiligheidsinstellingen aan te passen.",
    change_settings: "Instellingen wijzigen",
    show_more: "Meer tonen ...",
    display_sensitive_events: "APP: Gevoelige evenementen",
    display_sensitive_media: "APP: Gevoelige media",
    display_sensitive_media_web: "Web: Gevoelige media",
    tiles: "Tegels",
    list: "Lijst",
    filter: "Filter",
    pics: "Foto's",
    age: "Leeftijd",
    new: "Nieuw",
    ok: "OK",
    taps: "Taps",
    visitors: "Bezoekers",
    visited: "Bezocht",
    no_visitors: "Nog geen bezoekers",
    no_more_visitors: "Geen bezoekers meer",
    no_visited: "Nog geen bezoeken",
    no_more_visited: "Geen bezoeken meer",
    no_taps: "Geen taps",
    no_more_taps: "Geen taps meer",

    discreet_mode: "Onzichtbaar",
    discreet_mode_on: "Mask Mode (ON)",
    discreet_mode_off: "Mask Mode (OFF)",

    hide_profile_completely: "Profiel volledig verbergen",
    upgrade_to_pro: "Naar PRO upgraden",
    upgrade_to: "Upgraden naar",
    upgrade_now: "Nu upgraden",
    upgrade: "Upgraden",
    click_here_to_upgrade: "Klik hier om te upgraden",
    click_here_to_cancel: "Klik hier om te annuleren",
    pro: "PRO",
    cancel_pro: "PRO annuleren",
    thank_you_for_being_a_pro: "Bedankt dat je een PRO Buddy bent",
    successful_pro_upgrade: "Je bent nu een PRO Buddy!",
    failed_pro_upgrade: "Oeps... Er is iets misgegaan",
    we_hope_you_enjoyed_pro: "We hopen dat je genoten hebt van Buddy PRO",

    delete_this_message: "Dit bericht verwijderen?",
    delete: "Verwijderen",
    removed: "verwijderd",

    pro_slides_1_title: "Onzichtbaar",
    pro_slides_1_description: "met maskermodus",
    pro_slides_2_title: "Berichten afbreken",
    pro_slides_2_description: "en controleren of hij je berichten gelezen heeft",
    pro_slides_3_title: "Meer filters",
    pro_slides_4_title: "Onbeperkt",
    pro_slides_4_description: "favorieten, blokkeringen, bezoekers, openbare foto's & video's",
    pro_slides_5_title: "Meer plezier",
    pro_slides_5_description: "bekijk alle video's en foto's",

    notifications_button: 'Meldingen inschakelen',
    splash_notifications_title: 'Blijf op de hoogte',
    splash_notifications_description: 'Schakel meldingen in om berichten en waarschuwingen van je buddies te ontvangen',

    splash_blocks_title: "Onbeperkt blokkeren",
    splash_blocks_description: "om onbeperkt te kunnen blokkeren upgrade naar",
    splash_favorites_title: "Onbeperkte favorieten",
    splash_favorites_description: "voor onbeperkte favorieten upgrade naar",
    splash_mask_title: "onzichtbaar",
    splash_mask_description: "voor Onzichtbaar upgrade naar",
    splash_censored_title: "Meer zien",
    splash_censored_description: "voor ongelimiteerde inhoud upgrade naar",
    splash_visitors_title: "wie heeft mij bekeken",
    splash_visitors_description: "om al je bezoekers te bekijken upgrade naar",
    splash_filters_title: "Meer filters",
    splash_filters_description: "Voor meer filters, upgrade naar",
    splash_media_title: "Ongelimiteerde openbare foto's & video's",
    splash_media_description: "voor ongelimiteerde foto's/video's upgrade naar",
    splash_deletemsg_title: "Een bericht verwijderen",
    splash_deletemsg_description: "om een bericht te verwijderen upgrade naar",
    splash_change_settings_title: "Je media instellingen zijn ingesteld om je voor gevoelig materiaal te waarschuwen.",
    splash_change_settings_description: "Om het te kunnen zien, moet je je selectie in je veiligheidsinstellingen aanpassen.",
    splash_events_title: "Meer evenementen",
    splash_events_description: "voor onbeperkte favorieten upgrade naar",

    pro_upgrade_message_desktop: "Abonnementen worden automatisch verlengd, tenzij ze binnen 24 uur voor het einde van de huidige periode worden geannuleerd.<br>Bezoek <a href=\"http://cs.segpay.com\">SEGPAYEU.COM</a>, our authorized sales agent.<br>Charges will appear on your credit card statement as <a href=\"http://cs.segpay.com\">SEGPAYEU.COM*BUDDY</a>.",
    pro_upgrade_message_mobile: "Abonnementen worden automatisch verlengd, tenzij ze binnen 24 uur voor het einde van de huidige periode worden geannuleerd.",
    payment_blocked: "Het betalingsverzoek is in behandeling.",
    you_cant_send_messages_to_this_user: "Je kan geen berichten naar deze gebruiker sturen.",

    events: {
        report: {
            title: "Evenement rapporteren",
            wrong_type: "verkeerde categorie",
            illegal: "onwettig",
        },
        type: {
            friends: "Friends",
            fun: "Date",
            bang: "Chill",
            chemsfriendly: "chemsfriendly",
            required: "Gelieve een categorie te selecteren",
        },
        date: {
            today: "vandaag",
            tomorrow: "morgen",
            pick_date: "datum"
        },
        link_my_profile: "Mijn profiel linken",
        not_found: "Evenement niet gevonden",
        report_success: "Bedankt voor het rapporteren van dit evenement. We zullen het zo snel mogelijk nakijken",
        new_event: "Nieuw evenement",
        new_bang: "New bang",
        my_events: "Mijn evenementen",
        publish: "Publiceren",
        select_type: 'Wat voor soort evenement wil je creëren?',
        about_guide: "openbare evenementen voor iedereen (feesten, festivals, gemeenschap)",
        about_fun: "zoek een buddy voor privé 1:1 activiteiten",
        about_bang: "organiseer besloten groepsevenementen",
        invitation_only_event: "op uitnodiging (besloten evenement)",
        please_add_favourite_buddies_first: "Voeg eerst favoriete buddies toe",
        accept: "Accepteer",
        decline: "Afslaan",
        invited: "Invited",
        invite: "Invite",
    },

    clubs: {
        admin: 'Admin',
        invites: 'Invites',
        member: 'Member',
        nearby: 'Nearby',
        more_clubs: 'Meer clubs',
        hide_club_admin: "Clubbeheerder verbergen",
        report: {
            title: 'Club rapporteren',
            wrong_type: "verkeerde categorie",
            illegal: "onwettig",
        },
        type: {
            discover: 'Ontdekken',
            my_clubs: 'Mijn clubs',
            chemsfriendly: "chemsfriendly",
            required: "Gelieve een categorie te selecteren",
        },
        date: {
            today: "vandaag",
            tomorrow: "morgen",
            pick_date: "datum"
        },
        not_found: "Club niet gevonden",
        report_success: "Bedankt voor het rapporteren van deze club. We zullen het zo snel mogelijk nakijken",
        new_club: 'Nieuwe clubs',
        my_clubs: 'Mijn clubs',
        publish: 'Publish',
        invitation_only_club: "op uitnodiging (besloten club)",
        write_to_support_to_open_club: "Schrijf naar de support als je de privacy van deze club wilt wijzigen",
        please_add_favourite_buddies_first: "Voeg eerst favoriete buddies toe",
        accept: "Accepteer",
        decline: "Afslaan",
        invited: "Invited",
        invite: "Invite",
    },

    payment: {
        coming_soon: "Verschijnt binnenkort",
        month: "per maand",
        one_month: "maand",
        three_months: "maanden",
        twelve_months: "maanden",
        your_promotion_code: "Je promotiecode",
        please_select_payment_option: "Selecteer je betaalwijze",
        use_promo_code: "Gebruik een PROmo Code",
        credit_card: "Kredietkaart",
        alternative_payments: "Alternatieve betalingsmethoden",
        renews_automatically_until_cancelled: "Automatisch verlengd tot geannuleerd.",
        active_until: "Je PRO-status is actief tot",
        one_time: "Eenmalig",
        no_need_to_cancel: "(Geen annulering nodig!)",
        upgrade: {
            one_month: "Upgraden voor 1 maand",
            three_months: "Upgraden voor 3 maanden",
            twelve_months: "Upgraden voor 12 maanden",
        },
        upgrade_paypal: {
            one_month: "PayPal voor 1 maand",
            three_months: "PayPal voor 3 maanden",
            twelve_months: "PayPal voor 12 maanden",
        },
        send:"Verzenden",
        thank_you: "Dank je wel!",
        return_to_buddy: "Terug naar BUDDY",
        paypal: {
            message: "<p>Voer alsjeblieft je PayPal e-mailadres in.</p><br /> <p>We sturen je een PayPal-link naar dat adres.</p><br/><p>Nadat we de betaling hebben ontvangen, zullen we je Buddy-profiel upgraden.</p>",
            successMessage: "<p>We hebben je upgradeverzoek ontvangen.</p><br/><p>We sturen je binnenkort een Paypal-link.</p><br /><p>Na ontvangst van de betaling,<br /> geef ons alsjeblieft wat tijd om <br/>je upgrade uit te voeren.</p> <br/><p>We doen het met de hand! ✊🏻💦</p>"
        },
        features: {
            unlock_filters : "Alle filters ontgrendelen",
            be_invsble: "Onzichtbaar zijn",
            see_all_who_viewed_me: "Zien wie mij heeft bekeken",
            remove_messages: "Berichten verwijderen",
            make_notes_on_profile: "Notities maken bij profielen",
            unlimited_favorites: "Onbeperkt favorieten",
            view_hot_medias: "Bekijk XXX media in de app",
            see_if_your_message_has_been_read: "Zien of je bericht is gelezen",
            see_wh_marked_you_favorite: "Zien wie je als favoriet heeft gemarkeerd",
            hide_profile_visits: "Profielbezoeken verbergen"
        }
    },

    uploadVideos: {
        error: {
            lowDuration: "De lengte van de video mag niet minder dan 1 seconde zijn.",
            highDuration: "De lengte van de video mag niet meer dan 15 minuten zijn.",
        },
    },

    rush: {
        running_for_x_days: "Loopt voor {days} dag(en)",
        stars_and_strips_upgrade: "Stars and Strips. Upgraden naar",
        announce: "<span>Hi Buddies, </span><span>de makers van Buddy hebben iets nieuws voor je gecreëerd. </span><span>{0} zijn kleine apps binnen BUDDY die leuk en nuttig zijn, </span><span>Veel plezier en blijf nieuwsgierig!</span>",
        how_to: {
            title: "RUSH - Zo werkt het...",
            create: "Creëer je strip",
            name: "Geef je strip een naam",
            media: "Kies een foto of schrijf een tekst",
            publish: "Publiceer je strip en voeg meer inhoud toe",
        },
        welcome: {
            title: "Welkom bij RUSH",
            story: {
                title: "Je eigen verhaal.",
                description: "Voeg foto's toe aan je strip en laat ze aan alle buddies zien.",
            },
            post: {
                title: "Maak elke dag een bericht aan.",
                description: 'Laat de "Rush" langer duren en krijg een groter applaus."',
            },
            applause: {
                title: "Een groter applaus?!",
                description: "Dit geeft je een grotere preview titel. Dat betekent meer buddy bezichtigingen!",
            },
            attention: {
                title: "Opgelet!",
                description: "Als er binnen 24 uur geen nieuwe foto is, verdwijnt je strip. De 'Rush' is voorbij.",
            },
        },
    },
    sure_unblock_user: "Deblokkeer dit profiel?",

    party_on_buddies1: "PARTY ON,",
    party_on_buddies2: "BUDDIES!",
    party_on_text1: "There is something new in the Buddyverse. Check out the new \"Guide\" section in our calendar and find parties and events nearby.",
    party_on_text2: "After two years it's about time we go out again and have fun! Let's support event organisers together and rock the party.",

    are_you_sure_you_want_to_delete_all_sharing_links: "Weet u zeker dat u alle koppelingen voor delen wilt verwijderen?",
    all_links_will_be_deactivated: "Alle links worden gedeactiveerd.",
    all_sharing_links_deleted_successfully: "Alle links voor delen zijn succesvol verwijderd",
    this_is_your_sharing_code: "Dit is je deel-link (klik om te kopiëren)",
    share_your_selected_videos: "Deel je geselecteerde video's met<br>jongens die nog niet op Buddy zitten.",
    send_via_whatsapp: "Delen via Whatsapp",
    tap_on_the_videos_you_want_to_share: "Tik op de video's die je wilt delen",
    cancel_share: "Annuleren",
    share_now: "Deel nu ",
    status:"Toestand",
    you_need_to_be_a_pro_for_editing:"Je moet een <strong>PRO</strong> zijn om te kunnen bewerken",
    expire_at_date:"Verlopen op datum",
    expire_at_time:"Verlopen op tijd",
    views_limit:"Aantal weergaven",
    you_dont_have_any_links:"Je hebt geen links",
    link_settings_saved:"Linkinstellingen opgeslagen",
    can_not_get_sharing_links:"Kan geen links voor delen krijgen",
    copied_to_clipboard: "naar klembord gekopieerd",
    share_whatsapp_test: "Hier is de link naar mijn video op buddy.net:",
    share_videos: 'Video\'s delen',
    accept_all: 'Accepteer alles',
    no_messages : 'Geen berichten',
    you : 'Je',
    has: 'is erbij',
    have: 'hebt',
    joined: 'gekomen',
    left: 'over',
    web_push_notifications: 'Webpushmeldingen',
    modal_pro_upgrade_description : 'Geniet van deze en vele andere functies als je upgrade naar PRO.',
    modal_pro_visit_upgrade_description : 'Verberg je bezoek aan dit profiel met PRO',
    note : 'Opmerking',
    note_textarea_placeholder : "Voeg persoonlijke informatie over dit profiel toe...",
    who_marked_me_favorite : "Die mij als favoriet heeft aangemerkt",
    cancel_failed: "Annuleren is mislukt, probeer het nog eens",
    subscription_canceled: "Abonnement geannuleerd",
    confirm_cancel: "Weet u zeker dat u het abonnement wilt opzeggen?",
    cancel_subscription: "Abonnement opzeggen"
}
